import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import ViUdfoerer from './pages/ViUdfoerer'
import Sproejtemaling from './pages/Sproejtemaling'
import GalleryPage from './pages/GalleryPage'
import ContactPage from './pages/ContactPage'
import VideoPage from './pages/VideoPage'
import CookiePage from './pages/CookiePage'
import ServiceDetail from './pages/ServiceDetail'

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="relative min-h-screen flex flex-col bg-white text-gray-800 antialiased selection:bg-[#01529E] selection:text-white">
        {/* Header */}
        <Header />

        {/* Main Content */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vi-udfoerer" element={<ViUdfoerer />} />
            <Route path="/sproejtemaling" element={<Sproejtemaling />} />
            <Route path="/malerarbejde" element={<ServiceDetail serviceSlug="malerarbejde" />} />
            <Route path="/facademaling" element={<ServiceDetail serviceSlug="facademaling" />} />
            <Route path="/erhverv" element={<ServiceDetail serviceSlug="erhverv" />} />
            <Route path="/indvendig-maling" element={<ServiceDetail serviceSlug="indvendig-maling" />} />
            <Route path="/udvendig-maling" element={<ServiceDetail serviceSlug="udvendig-maling" />} />
            <Route path="/renovering-og-vedligeholdelse" element={<ServiceDetail serviceSlug="renovering-og-vedligeholdelse" />} />
            <Route path="/hoejtryksrensning" element={<ServiceDetail serviceSlug="hoejtryksrensning" />} />
            <Route path="/fuldspartling" element={<ServiceDetail serviceSlug="fuldspartling" />} />
            <Route path="/opsaetning-af-filt-og-tapet" element={<ServiceDetail serviceSlug="opsaetning-af-filt-og-tapet" />} />
            <Route path="/forsikringsskader" element={<ServiceDetail serviceSlug="forsikringsskader" />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/kontakt" element={<ContactPage />} />
            
            {/* Fallbacks & legacy routes */}
            <Route path="/galleri" element={<GalleryPage />} />
            <Route path="/video" element={<VideoPage />} />
            <Route path="/cookie" element={<CookiePage />} />
            
            {/* Fallback redirect or 404 */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  )
}

export default App
